export default function StatsBar() {
  const stats = [
    { value: '10,000+', label: '韩漫作品', icon: 'ri-book-line' },
    { value: '500万+', label: '月活读者', icon: 'ri-user-line' },
    { value: '每日更新', label: '最新章节', icon: 'ri-timer-line' },
    { value: '99.8%', label: '用户好评', icon: 'ri-thumb-up-line' },
  ];

  return (
    <section className="bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="flex flex-col items-center text-center p-4 rounded-xl bg-background-100">
              <div className="w-10 h-10 flex items-center justify-center text-accent-500 mb-2">
                <i className={`${stat.icon} text-2xl`}></i>
              </div>
              <span className="text-xl md:text-2xl font-bold text-foreground-900 whitespace-nowrap">{stat.value}</span>
              <span className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}